export default __webpack_public_path__ + "static/media/ryzen9.c1d0d6da.png";